export class DeleteDashboardError {
  public static readonly type = '[Project/Dashboard/List] DeleteDashboardError';
  constructor(public readonly error: Error) {}
}
